document.addEventListener("DOMContentLoaded", function () {
    const word = "ifoundyou";
    
    function replaceText(node) {
        if (node.nodeType === 3) {
            if (node.nodeValue.toLowerCase().includes(word)) {
                const span = document.createElement("span");
                span.innerHTML = node.nodeValue.replace(new RegExp(word, "gi"), '<span class="no-capitalize">$&</span>');
                node.parentNode.replaceChild(span, node);
            }
        } else if (node.nodeType === 1 && node.tagName !== "SCRIPT" && node.tagName !== "STYLE") {
            Array.from(node.childNodes).forEach(replaceText);
        }
    }

    replaceText(document.body);
});
